import HocSinh from "./HocSinh";

export default HocSinh